import { ProjectAttributes } from "../project-attributes";

export class ProjectSummaryResponse {
    projectID: string;
    projectName: string;
    default: boolean;
    primaryImage: string;
    sharedBy: string;
    tags: string[];
    nickname: string[];
    attributes?: ProjectAttributes;
    ownerUser: string | null;
    likes: number;
    application: any;
    ownerUserName: string;
    isFavorite: any;
    sharingProjectTypeID?: number;

    constructor(
        projectID: string,
        projectName: string,
        defaultt: boolean,
        primaryImage: string,
        sharedBy: string,
        tags: string[],
        nickname: string[],
        attributes?: ProjectAttributes,
        ownerUser: string = '',
        likes: number = 0,
        application?: any,
        ownerUserName: string = '',
        isFavorite?: any,
        sharingProjectTypeID?: number
    ) {
        this.projectID = projectID;
        this.projectName = projectName;
        this.default = defaultt;
        this.tags = tags;
        this.primaryImage = primaryImage;
        this.sharedBy = sharedBy;
        this.nickname = nickname;
        this.attributes = attributes;
        this.ownerUser = ownerUser;
        this.likes = likes
        this.application = application,
        this.ownerUserName = ownerUserName,
        this.isFavorite = isFavorite;
        this.sharingProjectTypeID = sharingProjectTypeID;
    }
}
